module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 184.15 38.01"}},[_c('title',[_v("mobile_logo2")]),_c('g',{attrs:{"data-name":"Layer 2","fill":"#565656"}},[_c('text',{attrs:{"transform":"translate(47.51 11.98)","font-size":"14","font-family":"Muli-Light, Muli"}},[_v("supported by")]),_c('text',{attrs:{"transform":"translate(0 33.08)","font-size":"16","font-family":"Muli-SemiBold, Muli","font-weight":"700"}},[_v("Google News Inititative")])])])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_logo2.svg
// module id = 972
// module chunks = 1